import { useState, useEffect, useCallback } from 'react';
import api from '../api/client';

export default function useRadioControl() {
  const [status, setStatus] = useState('OFFLINE');
  const [busy, setBusy] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/api/playback/status');
      setStatus(data.status || 'OFFLINE');
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    refresh();
    const iv = setInterval(refresh, 5000);
    return () => clearInterval(iv);
  }, [refresh]);

  const toggle = useCallback(async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (status === 'ONLINE') {
        await api.post('/api/playback/stop');
        setStatus('OFFLINE');
      } else {
        await api.post('/api/playback/start');
        setStatus('ONLINE');
      }
    } catch (e) {
      await refresh();
    } finally {
      setBusy(false);
    }
  }, [busy, status, refresh]);

  return { status, busy, toggle, refresh };
}
